import type { IConfContratosxservicios } from '@/modules/Contratacion/interfaces'

type ServicioConCups = Pick<IConfContratosxservicios, 'cup' | 'cupPersonalizado'>

export const cupPrincipalServicio = (servicio?: ServicioConCups | null) =>
  servicio?.cupPersonalizado ?? servicio?.cup

export const formatearCupsServicio = (servicio?: ServicioConCups | null) => {
  const principal = cupPrincipalServicio(servicio)
  if (!principal) return ''

  const textoPrincipal = [principal.cocuCups, principal.cocuNombre].filter(Boolean).join(' - ')
  if (!servicio?.cupPersonalizado || !servicio.cup) return textoPrincipal

  const normativo = [servicio.cup.cocuCups, servicio.cup.cocuNombre].filter(Boolean).join(' - ')
  return `${textoPrincipal} · Normativo: ${normativo}`
}
